<template class="h-full min-h-full">
  <router-view />
</template>

<script setup lang="ts">
</script>

<style scoped>

</style>
